import React, { Component, MouseEvent } from "react";

interface Props {
	containerClass?: string;
	currentPage: number;
	totalCount: number;
	pageSize: number;
	onChangePage: ( currentPage: number ) => void;
}

interface State {
	totalPages: number;
	pager: {
		currentPage: number;
		pages: number[];
	};
}

class Pagination extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		currentPage: 1,
		containerClass: "pagination-wrapper",
	};

	constructor( props: Props ) {
		super( props );
		const { totalCount, pageSize, currentPage } = props;
		let pages = Math.floor( ( totalCount / pageSize ) );
		pages = ( ( totalCount % pageSize ) === 0 ) ? pages : ( pages + 1 );
		this.state = {
			totalPages: pages,
			pager: {
				currentPage: currentPage,
				pages: [],
			},
		};
	}

	componentDidMount() {
		this.setPage( this.state.pager.currentPage, false );
	}

	UNSAFE_componentWillReceiveProps( nextProps: Readonly<Props> ): void {
		if ( nextProps ) {
			const { totalCount, pageSize, currentPage } = nextProps;
			if ( totalCount !== this.props.totalCount ) {
				let pages = Math.floor( ( totalCount / pageSize ) );
				pages = ( ( totalCount % pageSize ) === 0 ) ? pages : ( pages + 1 );
				this.setState( {
					totalPages: pages,
					pager: {
						currentPage: currentPage,
						pages: [],
					},
				}, () => {
					this.setPage( currentPage, false );
				} );
			}
		}
	}

	render() {
		const { pager, totalPages } = this.state;
		if ( pager.pages.length <= 1 ) {
			return null;
		}
		return ( <div className={ this.props.containerClass }>
			<ul className="pagination">
				<li className={ pager.currentPage === 1 ? "page-item disabled first-page-link" : "page-item first-page-link" }>
					<a href="#" className="page-link" onClick={ this.onFirst }>First</a>
				</li>
				<li className={ pager.currentPage === 1 ? "page-item disabled pre-page-link" : "page-item pre-page-link" }>
					<a href="#" className="page-link" onClick={ this.onPrevious }>Previous</a>
				</li>
				{ pager.pages.map( ( page: number, index: number ) =>
					<li key={ index } className={ pager.currentPage === page ? "page-item active" : "page-item" }>
						<a
							href="#" className="page-link" onClick={ ( e: MouseEvent ) => {
							e.preventDefault();
							this.setPage( page );
						} }>{ page }</a>
					</li>
				) }
				<li className={ pager.currentPage === totalPages ? "page-item disabled next-page-link" : "page-item next-page-link" }>
					<a href="#" className="page-link" onClick={ this.onNext }>Next</a>
				</li>
				<li className={ pager.currentPage === totalPages ? "page-item disabled last-page-link" : "page-item last-page-link" }>
					<a href="#" className="page-link" onClick={ this.onLast }>Last</a>
				</li>
			</ul>
		</div> );
	}

	private onFirst = ( e: MouseEvent ) => {
		e.preventDefault();
		const { pager } = this.state;
		if ( pager.currentPage !== 1 )
			this.setPage( 1 );
	};

	private onPrevious = ( e: MouseEvent ) => {
		e.preventDefault();
		const { pager } = this.state;
		if ( pager.currentPage !== 1 )
			this.setPage( pager.currentPage - 1 );
	};

	private onNext = ( e: MouseEvent ) => {
		e.preventDefault();
		const { pager, totalPages } = this.state;
		if ( pager.currentPage !== totalPages )
			this.setPage( pager.currentPage + 1 );
	};

	private onLast = ( e: MouseEvent ) => {
		e.preventDefault();
		const { pager, totalPages } = this.state;
		if ( pager.currentPage !== totalPages )
			this.setPage( totalPages );
	};

	private setPage( page: number, callback: boolean = true ) {
		const { totalPages } = this.state;
		if ( page < 1 || page > totalPages ) {
			return;
		}
		// get new pager object for specified page
		const newPager = this.getPager( totalPages, page );
		this.setState( { pager: newPager }, () => {
			if ( callback )
				this.props.onChangePage( newPager.currentPage );
		} );
	}

	private getPager( totalPages: number, currentPage: number ) {
		let startPage: number, endPage: number;
		if ( totalPages <= 10 ) {
			// less than 10 total pages so show all
			startPage = 1;
			endPage = totalPages;
		} else {
			// more than 10 total pages so calculate start and end pages
			if ( currentPage <= 6 ) {
				startPage = 1;
				endPage = 10;
			} else if ( currentPage + 4 >= totalPages ) {
				startPage = totalPages - 9;
				endPage = totalPages;
			} else {
				startPage = currentPage - 5;
				endPage = currentPage + 4;
			}
		}
		// create an array of pages to ng-repeat in the pager control
		// @ts-ignore
		const pages = [ ...Array( ( endPage + 1 ) - startPage ).keys() ].map( ( i ) => {
			return ( startPage + i );
		} );
		return {
			currentPage: currentPage,
			pages: pages
		};
	}
}

export default Pagination;
